import {Workbook, WorkbookFormat, WorkbookLoadOptions, WorkbookSaveOptions} from 'igniteui-angular-excel';
import {IgxSpreadsheetComponent} from 'igniteui-angular-spreadsheet';
import * as XLSX from 'xlsx';
import {ClsUtil} from "./cls-util";

export class ExcelUtility {
  public static getExtension(format: WorkbookFormat) {
    switch (format) {
      case WorkbookFormat.StrictOpenXml:
      case WorkbookFormat.Excel2007:
        return '.xlsx';
      case WorkbookFormat.Excel2007MacroEnabled:
        return '.xlsm';
      case WorkbookFormat.Excel2007MacroEnabledTemplate:
        return '.xltm';
      case WorkbookFormat.Excel2007Template:
        return '.xltx';
      case WorkbookFormat.Excel97To2003:
        return '.xls';
      case WorkbookFormat.Excel97To2003Template:
        return '.xlt';
    }
  }

  public static load(file: File): Promise<Workbook> {
    if (file.size === 0) {
      throw new Error('MENSAJES.ALERT.DOC_VACIO_DANIADO');
    }
    return new Promise<Workbook>((resolve, reject) => {
      ExcelUtility.readFileAsUint8Array(file).then((a) => {
        // CHANGE #2: use optimised load‑options
        const opts = new WorkbookLoadOptions();
        // opts.isDuplicateFormulaParsingOptimized = true;
        // opts.autoResumeCalculations = false; // we’ll resume manually later

        Workbook.load(a, opts, (w) => {
          resolve(w);
        }, (e) => {
          reject(e);
        });
      }, (e) => {
        reject(e);
      });
    });
  }

  public static loadXLSX(file: File): Promise<XLSX.WorkBook> {
    if (file.size === 0) {
      throw new Error('MENSAJES.ALERT.DOC_VACIO_DANIADO');
    }
    return new Promise<XLSX.WorkBook>((resolve, reject) => {
      ClsUtil.convertBlobOrFileToBase64String(file).then((base64: any) => {
        base64 = base64.toString().split('base64,')[1];
        resolve(XLSX.read(base64));
      }, (e) => {
        reject(e);
      });
    });
  }

  public static ubicaHojaXLSX(libro: XLSX.WorkBook, nomHoja: string) {
    try {
      return libro.SheetNames.findIndex(hoja => hoja === nomHoja);
    } catch (e) {
      return -1;
    }
  }

  public static loadFromUrl(url: string): Promise<Workbook> {
    return new Promise<Workbook>((resolve, reject) => {
      const req = new XMLHttpRequest();
      req.open('GET', url, true);
      req.responseType = 'arraybuffer';
      req.onload = (d) => {
        // CHANGE #3: no extra string/loop – use the ArrayBuffer directly
        const data = new Uint8Array(req.response);

        const opts = new WorkbookLoadOptions();
        // opts.isDuplicateFormulaParsingOptimized = true;
        // opts.autoResumeCalculations = false;

        Workbook.load(data, opts, (w) => {
          resolve(w);
        }, (e) => {
          reject(e.message);
        });
      };
      req.onerror = (error) => {
        reject('MENSAJE.ERROR.CARGAR_ARCHIVO_URL');
      };
      req.send();
    });
  }

  public static save(workbook: Workbook, fileNameWithoutExtension: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const opt = new WorkbookSaveOptions();
      opt.type = 'blob';

      workbook.save(opt, (d) => {
        const fileExt = ExcelUtility.getExtension(workbook.currentFormat);
        const fileName = fileNameWithoutExtension + fileExt;
        ClsUtil.descargarArchivo(d as Blob, fileName)
        resolve(fileName);
      }, (e) => {
        reject(e.message);
      });
    });
  }

  public static saveBlob(workbook: Workbook): Promise<Blob> {
    return new Promise<Blob>((resolve, reject) => {
      const opt = new WorkbookSaveOptions();
      opt.type = 'blob';
      workbook.save(opt, (d) => {
        resolve(d as Blob);
      }, (e) => {
        reject(e.message);
      });
    });
  }

  public static saveUint8Array(workbook: Workbook): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const opt = new WorkbookSaveOptions();
      opt.type = 'uint8array';
      workbook.save(opt, (d) => {
        resolve(d as any);
      }, (e) => {
        reject(e.message);
      });
    });
  }

  public static saveSS(spreadsheet: IgxSpreadsheetComponent, fileNameWithExtension: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const opt = new WorkbookSaveOptions();
      opt.type = 'blob';
      // se reestablece valores defaults
      // spreadsheet.isFormulaBarVisible = true;
      // spreadsheet.isInEndMode = true;
      // spreadsheet.areGridlinesVisible = true;
      // spreadsheet.areHeadersVisible = true;
      // spreadsheet.workbook.windowOptions.tabBarVisible = true;
      spreadsheet.workbook.save(opt, (d) => {
        // const fileExt = ExcelUtility.getExtension(spreadsheet.workbook.currentFormat);
        // const fileName = fileNameWithExtension;
        ClsUtil.descargarArchivo(d as Blob, fileNameWithExtension);
        resolve(fileNameWithExtension);
      }, (e) => {
        reject(e.message);
      });
    });
  }

  /**
   * CHANGE #1:
   * Always read the file as ArrayBuffer and wrap it in a Uint8Array.
   * This eliminates the costly deprecated readAsBinaryString branch.
   */
  private static readFileAsUint8Array(file: File): Promise<Uint8Array> {
    return new Promise<Uint8Array>((resolve, reject) => {
      const fr = new FileReader();
      fr.onerror = () => reject(fr.error);

      fr.onload = () => resolve(new Uint8Array(fr.result as ArrayBuffer));
      fr.readAsArrayBuffer(file);
    });
  }
}
